import {
    isArray,
    isNil,
    isObject,
    lowerFirst as lodashLowerFirst,
    upperFirst as lodashUpperFirst,
    map,
    memoize,
    transform,
    upperCase,
} from 'lodash';

// recursive camel-casing filters

export function transformKeys(obj: $TSFixMe, transformer: $TSFixMe): $TSFixMe {
    if (isNil(obj)) {
        return obj;
    }

    if (isArray(obj)) {
        return map(obj, (o) => transformKeys(o, transformer));
    }

    if (isObject(obj)) {
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        return transform(obj, (result, value, key) => {
            result[transformer(key)] = transformKeys(value, transformer);
        });
    }

    return obj;
}

export const lowerFirst = memoize(toLowerFirst);

export const upperFirst = memoize(toUpperFirst);

function toLowerFirst(key: $TSFixMe) {
    return key === upperCase(key) ? key : lodashLowerFirst(key);
}

function toUpperFirst(key: $TSFixMe) {
    return lodashUpperFirst(key);
}
